import React from 'react';

const NewFilePopup = ({ show, onClose, onConfirm, fileName }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Upload Prescription</h3>
                <p className="text-gray-700 mb-4">
                    Are you sure you want to upload the following prescription file(s)?
                </p>
                <div className="bg-gray-50 p-3 rounded-lg mb-4 max-h-32 overflow-auto">
                    {Array.isArray(fileName) ? (
                        fileName.map((name, index) => (
                            <div key={index} className="py-1 px-2 text-sm text-gray-700">
                                {typeof name === 'string' ? name : name?.name || 'Unknown file'}
                            </div>
                        ))
                    ) : (
                        <div className="py-1 px-2 text-sm text-gray-700">
                            {fileName}
                        </div>
                    )}
                </div>
                <div className="flex justify-end gap-4">
                    <button 
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 text-gray-800 rounded hover:bg-gray-200 transition-all duration-200"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={onConfirm}
                        className="px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 text-white rounded hover:from-red-600 hover:to-red-700 transition-all duration-200"
                    >
                        Upload
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewFilePopup;